module.exports = __webpack_public_path__ + "static/rainbowblanket-05d1e8e3c0074883179b65c80b20b118.jpeg";